const games = [
    {
        id: 'cyberpunk-2077',
        title: 'Cyberpunk 2077',
        category: 'action',
        tags: ['rpg', 'open-world', 'singleplayer', 'fps'],
        active: true,
        gradient: 'from-amber-600 to-red-600',
        supportedModIds: [
            'god-mode', 'one-hit-kill', 'infinite-ammo', 'no-reload', 'no-recoil', 
            'no-spread', 'infinite-grenades', 'instant-charge', 'jam-enemy-weapons',
            'infinite-ram', 'cyberware-no-cooldown', 'freeze-hack-timers', 'stealth-mode',
            'infinite-stamina', 'no-fall-damage', 'vehicle-indestructible', 'teleport-waypoint',
            'reset-wanted', 'speed-multiplier', 'jump-height', 'infinite-money',
            'infinite-crafting-mats', 'money-amount', 'add-perk-points', 'add-attribute-points',
            'xp-multiplier', 'street-cred', 'no-hud', 'time-of-day', 'weather'
        ]
    },
    {
        id: 'the-witcher-3',
        title: 'The Witcher 3',
        category: 'rpg',
        tags: ['rpg', 'open-world', 'singleplayer', 'fantasy'],
        active: false,
        gradient: 'from-orange-600 to-amber-500',
        supportedModIds: [
            'god-mode', 'infinite-stamina', 'speed-multiplier', 'infinite-money',
            'xp-multiplier', 'no-fall-damage', 'jump-height', 'teleport',
            'toxicity-ignore', 'weather-control', 'instant-sign-cast'
        ]
    },
    {
        id: 'elden-ring',
        title: 'Elden Ring',
        category: 'action',
        tags: ['rpg', 'souls-like', 'singleplayer', 'fantasy'],
        active: false,
        gradient: 'from-amber-500 to-red-500',
        supportedModIds: [
            'god-mode', 'infinite-stamina', 'speed-multiplier', 'xp-multiplier',
            'no-fall-damage', 'jump-height', 'instant-death', 'infinite-fp',
            'rune-multiplier'
        ]
    },
    {
        id: 'starfield',
        title: 'Starfield',
        category: 'rpg',
        tags: ['rpg', 'open-world', 'singleplayer', 'sci-fi', 'fps'],
        active: false,
        gradient: 'from-stone-700 to-amber-700',
        supportedModIds: [
            'god-mode', 'infinite-stamina', 'speed-multiplier', 'infinite-ammo',
            'no-recoil', 'infinite-money', 'xp-multiplier', 'no-fall-damage',
            'jump-height', 'teleport'
        ]
    },
    // Adding user's games dynamically for testing their local env
    {
        id: 'beamng-drive',
        title: 'BeamNG.drive',
        category: 'action',
        tags: ['simulation', 'driving', 'physics'],
        active: false,
        gradient: 'from-orange-500 to-yellow-500',
        supportedModIds: ['god-mode', 'speed-multiplier', 'jump-height']
    },
    {
        id: 'drug-dealer-simulator-2',
        title: 'Drug Dealer Simulator 2',
        category: 'action',
        tags: ['simulation', 'co-op', 'first-person', 'drugs', 'open-world', 'crafting'],
        active: true,
        gradient: 'from-emerald-500 to-teal-500',
        coverUrl: 'https://shared.fastly.steamstatic.com/store_item_assets/steam/apps/1708850/header.jpg',
        bannerUrl: 'https://shared.fastly.steamstatic.com/store_item_assets/steam/apps/1708850/library_hero.jpg',
        supportedModIds: [
            'dds2-set-money', 'dds2-set-bank', 'dds2-price-markup', 'dds2-rent-free', 'dds2-no-cost',
            'dds2-demand-boost', 'dds2-drug-quality', 'dds2-mix-master', 'dds2-lab-temp', 'dds2-xp-multiplier',
            'dds2-shop-restock', 'dds2-shop-buy-limit', 'dds2-shop-rep', 'dds2-price-discount', 'dds2-wholesale-boost',
            'dds2-walk-speed', 'dds2-crouch-speed', 'dds2-stamina-free', 'dds2-health-regen', 'dds2-stress-free',
            'dds2-weapon-speed', 'dds2-weapon-force', 'dds2-weapon-bleed', 'dds2-weapon-stun',
            'dds2-inventory-slots', 'dds2-concealed-slots', 'dds2-weight-zero', 'dds2-backpack-upgrade',
            'dds2-rep-gain-boost', 'dds2-rep-no-drop', 'dds2-cartel-boost', 'dds2-territory-control',
            'dds2-speed-boost-buff', 'dds2-cost-reduction-buff',
            'dds2-troll-launch', 'dds2-troll-slowmo', 'dds2-troll-steal-boost', 'dds2-troll-police-magnet',
            'dds2-troll-cartel-hit', 'dds2-troll-inventory-drop', 'dds2-troll-freeze', 'dds2-troll-respawn-delay',
            'dds2-troll-fear-factor', 'dds2-troll-movement-swap'
        ]
    },
    {
        id: 'mall-rivals',
        title: 'Mall Rivals',
        category: 'simulation',
        tags: ['simulation', 'management', 'strategy', 'casual'],
        active: true,
        gradient: 'from-rose-600 to-orange-500',
        supportedModIds: [
            'income-multiplier', 'cost-reduction', 'rent-reduction', 'xp-boost', 'price-markup', 'add-money', 'infinite-premium',
            'mr-build-speed', 'mr-restock-speed', 'staff-efficiency', 'staff-stamina', 'expansion-speed', 'unlock-shops', 'place-anywhere',
            'customer-flow', 'vip-ratio', 'spending-boost', 'satisfaction-boost', 'no-complaints',
            'infinite-money', 'zero-costs', 'instant-build', 'instant-restock',
            'customer-magnet', 'magnet-strength', 'vip-steal', 'redirect-flow', 'slow-restock', 'tank-prices', 'steal-inventory', 'spawn-trash', 'fake-health-inspector', 'freeze-opponent-staff', 'destroy-ratings', 'bankrupt-opponents',
            'freeze-time', 'univ-speedhack', 'anti-report', 'packet-manipulation'
        ]
    },
    {
        id: 'gladio-and-glory',
        title: 'Gladio and Glory',
        category: 'action',
        tags: ['action', 'arena', 'multiplayer', 'gladiator', 'combat', 'melee'],
        active: true,
        gradient: 'from-red-700 to-amber-500',
        supportedModIds: [
            'gg-health-multiplier', 'gg-max-health', 'gg-damage-multiplier', 'gg-base-damage', 'gg-speed-multiplier', 'gg-armor-boost',
            'gg-stamina-regen', 'gg-stamina-cost-reduction', 'gg-max-stamina', 'gg-infinite-stamina',
            'gg-glory-multiplier', 'gg-kill-score-boost', 'gg-kill-boost',
            'gg-hp-boost-on-kill', 'gg-power-boost-on-kill', 'gg-attack-speed',
            'gg-god-mode', 'gg-one-hit-kill',
            'gg-weapon-damage-boost', 'gg-throw-damage',
            'gg-anti-report'
        ]
    },
    {
        id: 'war-selection',
        title: 'War Selection',
        category: 'strategy',
        tags: ['rpg', 'rts', 'multiplayer', 'survival', 'battle-royale'],
        active: true,
        useSteam: true,
        steamAppId: '1022450',
        gradient: 'from-red-800 to-orange-700',
        supportedModIds: [
            'kernel-stealth', 'thread-cloaking', 'hwid-spoofer',
            'food-multiplier', 'wood-multiplier', 'stone-multiplier', 'iron-multiplier', 'global-income-boost', 'reduced-costs', 'pop-cap-boost', 'zero-pop-cost',
            'unit-hp-buff', 'unit-damage-buff', 'unit-speed-buff', 'unit-armor-buff', 'unit-range-buff', 'unit-heal-regen',
            'train-speed', 'build-speed', 'research-speed', 'age-up-speed',
            'god-mode-units', 'one-hit-kill', 'instant-train', 'instant-build',
            'maphack', 'partial-fog', 'esp-units', 'zoom-hack', 'screenshot-cleaner',
            'report-blocker', 'drain-enemy-banks', 'drain-speed', 'nuke-economy', 'mind-control', 'force-lag-spike', 'crash-lobby'
        ]
    },
    {
        id: 'upload-labs',
        title: 'Upload Labs',
        category: 'simulation',
        tags: ['idle', 'incremental', 'hacking', 'simulation', 'singleplayer'],
        active: true,
        useSteam: true,
        steamAppId: '3606890',
        gradient: 'from-blue-600 to-indigo-800',
        supportedModIds: [
            'ul-money-multiplier', 'ul-set-money', 'ul-research-multiplier',
            'ul-tokens-multiplier', 'ul-set-tokens', 'ul-file-value-multiplier',
            'ul-offline-earnings-mult', 'ul-node-cost-reduction',
            'ul-global-speedhack', 'ul-instant-download', 'ul-instant-upload',
            'ul-instant-process', 'ul-instant-research', 'ul-instant-hack',
            'ul-instant-commit', 'ul-no-cooldowns', 'ul-auto-upgrade', 'ul-auto-collect',
            'ul-infinite-portals', 'ul-infinite-threads', 'ul-unlock-all-nodes',
            'ul-no-bottlenecks', 'ul-virus-immunity',
            'ul-zero-cost', 'ul-creative-mode', 'ul-achievement-unlock'
        ]
    }
]

const modData = {
    'cyberpunk-2077': {
        categories: [
            {
                id: 'combat',
                name: 'Kampfsystem',
                mods: [
                    { id: 'god-mode', type: 'toggle', name: 'God Mode', description: 'Vollständige Unverwundbarkeit gegen jeglichen Schaden', enabled: false },
                    { id: 'one-hit-kill', type: 'toggle', name: 'One-Hit Kills', description: 'Gegner sterben bei einem Treffer', enabled: false },
                    { id: 'infinite-ammo', type: 'toggle', name: 'Unendliche Munition', description: 'Munition wird nicht verbraucht', enabled: false },
                    { id: 'no-reload', type: 'toggle', name: 'Kein Nachladen', description: 'Waffen müssen nie nachgeladen werden', enabled: false },
                    { id: 'no-recoil', type: 'toggle', name: 'Kein Rückstoß', description: 'Waffe verzieht nicht beim Schießen', enabled: false },
                    { id: 'no-spread', type: 'toggle', name: 'Keine Streuung', description: 'Kugeln treffen immer genau ins Fadenkreuz', enabled: false },
                    { id: 'infinite-grenades', type: 'toggle', name: 'Unendliche Granaten', description: 'Granaten-Zähler sinkt nicht', enabled: false },
                    { id: 'instant-charge', type: 'toggle', name: 'Insta-Charge Tech-Waffen', description: 'Tech-Waffen laden sofort voll auf', enabled: false },
                    { id: 'jam-enemy-weapons', type: 'toggle', name: 'Gegner-Waffen blockieren', description: 'Gegner können nicht mehr schießen', enabled: false }
                ]
            },
            {
                id: 'cyberware',
                name: 'Cyberware & Quickhacks',
                mods: [
                    { id: 'infinite-ram', type: 'toggle', name: 'Unendlicher RAM', description: 'Quickhacks kosten keinen RAM', enabled: false },
                    { id: 'cyberware-no-cooldown', type: 'toggle', name: 'Cyberware No-Cooldown', description: 'Sandevistan & Co. sind sofort wieder bereit', enabled: false },
                    { id: 'freeze-hack-timers', type: 'toggle', name: 'Breach Protocol einfrieren', description: 'Der Timer beim Hacking bleibt stehen', enabled: false },
                    { id: 'stealth-mode', type: 'toggle', name: 'Geist-Modus (Unsichtbar)', description: 'Kameras und Gegner bemerken dich nicht', enabled: false }
                ]
            },
            {
                id: 'gameplay',
                name: 'Bewegung & Welt',
                mods: [
                    { id: 'infinite-stamina', type: 'toggle', name: 'Unendliche Ausdauer', description: 'Sprinten ohne Erschöpfung', enabled: false },
                    { id: 'no-fall-damage', type: 'toggle', name: 'Kein Fallschaden', description: 'Stürze aus beliebiger Höhe überleben', enabled: false },
                    { id: 'vehicle-indestructible', type: 'toggle', name: 'Unzerstörbare Fahrzeuge', description: 'Autos nehmen keinen Schaden', enabled: false },
                    { id: 'teleport-waypoint', type: 'toggle', name: 'Zum Wegpunkt teleportieren', description: 'Teleportiert V sofort zur Markierung auf der Karte', enabled: false },
                    { id: 'reset-wanted', type: 'toggle', name: 'Fahndungslevel löschen', description: 'NCPD bricht die Verfolgung sofort ab', enabled: false },
                    { id: 'speed-multiplier', type: 'slider', name: 'Geschwindigkeit', description: 'Laufgeschwindigkeit anpassen', min: 1, max: 10, value: 1, unit: 'x' },
                    { id: 'jump-height', type: 'slider', name: 'Sprungkraft', description: 'Höher springen', min: 1, max: 5, value: 1, unit: 'x' }
                ]
            },
            {
                id: 'resources',
                name: 'Ressourcen & RPG',
                mods: [
                    { id: 'infinite-money', type: 'toggle', name: 'Geld einfrieren', description: 'Eurodollars sinken nicht bei Käufen', enabled: false },
                    { id: 'infinite-crafting-mats', type: 'toggle', name: 'Unendliche Crafting-Materialien', description: 'Komponenten beim Craften nicht verbrauchen', enabled: false },
                    { id: 'money-amount', type: 'slider', name: 'Eurodollars hinzufügen', description: 'Geldkonto sofort aufstocken', min: 0, max: 9999999, value: 0, unit: '€$' },
                    { id: 'add-perk-points', type: 'slider', name: 'Vorteilspunkte', description: 'Perk Points hinzufügen', min: 0, max: 100, value: 0, unit: ' Pkt' },
                    { id: 'add-attribute-points', type: 'slider', name: 'Attributspunkte', description: 'Attribute Points hinzufügen', min: 0, max: 50, value: 0, unit: ' Pkt' },
                    { id: 'xp-multiplier', type: 'slider', name: 'Level XP Multiplikator', description: 'Erhalte mehr Erfahrungspunkte', min: 1, max: 50, value: 1, unit: 'x' },
                    { id: 'street-cred', type: 'slider', name: 'Street Cred Multiplikator', description: 'Erhalte schneller Street Cred', min: 1, max: 50, value: 1, unit: 'x' }
                ]
            },
            {
                id: 'visual',
                name: 'Visuelle Effekte',
                mods: [
                    { id: 'no-hud', type: 'toggle', name: 'HUD ausblenden', description: 'Cinematic Mode für perfekte Screenshots', enabled: false },
                    { id: 'time-of-day', type: 'dropdown', name: 'Tageszeit festlegen', options: ['Sonnenaufgang', 'Mittag', 'Sonnenuntergang', 'Mitternacht'], selected: null },
                    { id: 'weather', type: 'dropdown', name: 'Wetter erzwingen', options: ['Klar', 'Bewölkt', 'Regen', 'Nebel', 'Sandsturm', 'Smog'], selected: null }
                ]
            }
        ]
    },
    'the-witcher-3': {
        categories: [
            {
                id: 'gameplay',
                name: 'Gameplay',
                mods: [
                    { id: 'god-mode', type: 'toggle', name: 'God Mode', description: 'Unverwundbarkeit', enabled: false },
                    { id: 'infinite-stamina', type: 'toggle', name: 'Unendliche Ausdauer', description: 'Keine Erschöpfung', enabled: false },
                ]
            }
        ]
    },
    'elden-ring': {
        categories: [
            {
                id: 'gameplay',
                name: 'Gameplay',
                mods: [
                    { id: 'god-mode', type: 'toggle', name: 'God Mode', description: 'Unverwundbarkeit', enabled: false },
                ]
            }
        ]
    },
    'starfield': {
        categories: [
            {
                id: 'gameplay',
                name: 'Gameplay',
                mods: [
                    { id: 'god-mode', type: 'toggle', name: 'God Mode', description: 'Unverwundbarkeit', enabled: false },
                ]
            }
        ]
    },
    'beamng-drive': {
        categories: [
            {
                id: 'gameplay',
                name: 'Gameplay',
                mods: [
                    { id: 'god-mode', type: 'toggle', name: 'Car God Mode', description: 'Kein physikalischer Schaden am Auto', enabled: false },
                    { id: 'speed-multiplier', type: 'slider', name: 'Motorleistung Multiplikator', min: 1, max: 10, value: 1, unit: 'x' },
                    { id: 'jump-height', type: 'slider', name: 'Mond Gravitation / Sprung', min: 1, max: 5, value: 1, unit: 'x' },
                ]
            }
        ]
    },
    'drug-dealer-simulator-2': {
        categories: [
            {
                id: 'money-business',
                name: '💰 Geld & Business',
                mods: [
                    { id: 'dds2-set-money', type: 'slider', name: 'Bares setzen', description: 'SetAccountMoney – Bargeld direkt setzen', min: 1000, max: 10000000, value: 100000, step: 10000, unit: ' $' },
                    { id: 'dds2-set-bank', type: 'slider', name: 'Bankkonto setzen', description: 'SetBankMoney – Banksaldo setzen', min: 1000, max: 10000000, value: 500000, step: 50000, unit: ' $' },
                    { id: 'dds2-price-markup', type: 'slider', name: 'Verkaufspreis-Boost', description: 'AveragePricePerGram erhöhen', min: 1, max: 10, value: 2, step: 0.5, unit: 'x' },
                    { id: 'dds2-rent-free', type: 'toggle', name: 'Mietfrei', description: 'RentCostDaily auf $0', enabled: false },
                    { id: 'dds2-no-cost', type: 'toggle', name: 'Gratis einkaufen', description: 'BuyCostTotal auf $0 – AUFFÄLLIG', enabled: false }
                ]
            },
            {
                id: 'drug-lab',
                name: '🧪 Labor & Drogen',
                mods: [
                    { id: 'dds2-demand-boost', type: 'slider', name: 'Nachfrage-Boost', description: 'DrugDemandModifier – mehr Kunden wollen kaufen', min: 1, max: 10, value: 3, step: 1, unit: 'x' },
                    { id: 'dds2-drug-quality', type: 'slider', name: 'Reinheitsgrad', description: 'Drug-Quality auf Maximum', min: 50, max: 100, value: 95, step: 5, unit: '%' },
                    { id: 'dds2-mix-master', type: 'toggle', name: 'Mix-Meister', description: 'MixAmount auf Maximum – weniger Verlust', enabled: false },
                    { id: 'dds2-lab-temp', type: 'toggle', name: 'Perfekte Labor-Temperatur', description: 'RoomTemperature = OptimalTemperature', enabled: false },
                    { id: 'dds2-xp-multiplier', type: 'slider', name: 'XP Multiplikator', description: 'XPEarned multiplizieren', min: 1, max: 10, value: 3, step: 1, unit: 'x' }
                ]
            },
            {
                id: 'shop-system',
                name: '🏪 Shop & Handel',
                mods: [
                    { id: 'dds2-shop-restock', type: 'slider', name: 'Restock-Intervall', description: 'ShopRestockInterval reduzieren', min: 0.1, max: 1, value: 0.3, step: 0.1, unit: 'x' },
                    { id: 'dds2-shop-buy-limit', type: 'slider', name: 'Einkaufslimit', description: 'AddShopBuyLimit erhöhen', min: 1, max: 20, value: 5, step: 1, unit: 'x' },
                    { id: 'dds2-shop-rep', type: 'toggle', name: 'Sofort voller Shop-Ruf', description: 'AddShopReputationPoints Maximum', enabled: false },
                    { id: 'dds2-price-discount', type: 'slider', name: 'Einkaufsrabatt', description: 'PriceDiscountPerLevel – billiger einkaufen', min: 1, max: 10, value: 3, step: 1, unit: 'x' },
                    { id: 'dds2-wholesale-boost', type: 'slider', name: 'Großhandel-Boost', description: 'WholesaleMap Preise verbessern', min: 1, max: 5, value: 2, step: 0.5, unit: 'x' }
                ]
            },
            {
                id: 'movement-combat',
                name: '🏃 Bewegung & Kampf',
                mods: [
                    { id: 'dds2-walk-speed', type: 'slider', name: 'Laufgeschwindigkeit', description: 'MaxWalkSpeed erhöhen', min: 1, max: 5, value: 1.5, step: 0.25, unit: 'x' },
                    { id: 'dds2-crouch-speed', type: 'slider', name: 'Schleich-Speed', description: 'MaxWalkSpeedCrouched erhöhen', min: 1, max: 5, value: 2, step: 0.25, unit: 'x' },
                    { id: 'dds2-stamina-free', type: 'toggle', name: 'Keine Ausdauer-Kosten', description: 'StaminaUseSwing auf 0', enabled: false },
                    { id: 'dds2-health-regen', type: 'slider', name: 'HP-Regeneration', description: 'HealthRegen Tempo erhöhen', min: 1, max: 20, value: 5, step: 1, unit: 'x' },
                    { id: 'dds2-stress-free', type: 'toggle', name: 'Stressfrei', description: 'StressPerSecond auf 0', enabled: false }
                ]
            },
            {
                id: 'weapons',
                name: '🔫 Waffen',
                mods: [
                    { id: 'dds2-weapon-speed', type: 'slider', name: 'Waffengeschwindigkeit', description: 'WeaponSpeed erhöhen', min: 1, max: 5, value: 2, step: 0.5, unit: 'x' },
                    { id: 'dds2-weapon-force', type: 'slider', name: 'Waffen-Kraft', description: 'WeaponForce – mehr Schaden', min: 1, max: 10, value: 3, step: 1, unit: 'x' },
                    { id: 'dds2-weapon-bleed', type: 'slider', name: 'Blutungs-Chance', description: 'WeaponBleedChance erhöhen', min: 0, max: 100, value: 50, step: 10, unit: '%' },
                    { id: 'dds2-weapon-stun', type: 'slider', name: 'Stun-Chance', description: 'WeaponStunChance erhöhen', min: 0, max: 100, value: 50, step: 10, unit: '%' }
                ]
            },
            {
                id: 'inventory',
                name: '🎒 Inventar',
                mods: [
                    { id: 'dds2-inventory-slots', type: 'slider', name: 'Inventar-Slots', description: 'GetInventoryLenght erweitern', min: 10, max: 200, value: 50, step: 10, unit: ' Slots' },
                    { id: 'dds2-concealed-slots', type: 'slider', name: 'Versteckte Slots', description: 'InventoryConceladSlotCount erhöhen', min: 5, max: 100, value: 30, step: 5, unit: ' Slots' },
                    { id: 'dds2-weight-zero', type: 'toggle', name: 'Gewichtlos', description: 'WeightClothes auf 0', enabled: false },
                    { id: 'dds2-backpack-upgrade', type: 'slider', name: 'Quick-Slots', description: 'BaseQuickSlotCount erhöhen', min: 4, max: 20, value: 10, step: 1, unit: ' Slots' }
                ]
            },
            {
                id: 'reputation-cartel',
                name: '🌍 Reputation & Kartell',
                mods: [
                    { id: 'dds2-rep-gain-boost', type: 'slider', name: 'Ruf-Gewinn Boost', description: 'ReputationGainPerMoneyUnit multiplizieren', min: 1, max: 10, value: 3, step: 1, unit: 'x' },
                    { id: 'dds2-rep-no-drop', type: 'toggle', name: 'Kein Ruf-Verlust', description: 'ReputationDropPerDay auf 0', enabled: false },
                    { id: 'dds2-cartel-boost', type: 'slider', name: 'Kartell-Aufstieg', description: 'Schneller im Rang steigen', min: 1, max: 5, value: 2, step: 1, unit: 'x' },
                    { id: 'dds2-territory-control', type: 'toggle', name: 'Gebietskontrolle', description: 'Territorium-Übernahme beschleunigen', enabled: false }
                ]
            },
            {
                id: 'active-buffs',
                name: '⚡ Aktive Buffs',
                mods: [
                    { id: 'dds2-speed-boost-buff', type: 'slider', name: 'Speed-Boost', description: 'TempHighSpeedBoostPercent', min: 10, max: 200, value: 50, step: 10, unit: '%' },
                    { id: 'dds2-cost-reduction-buff', type: 'slider', name: 'Kosten-Reduktion', description: 'TempHighCostRisePercent umkehren', min: 10, max: 100, value: 50, step: 10, unit: '% billiger' }
                ]
            },
            {
                id: 'freunde-trollen',
                name: '😈 Freunde Trollen (Co-Op)',
                mods: [
                    { id: 'dds2-troll-launch', type: 'slider', name: '🚀 Katapult', description: 'LaunchCharacter – schießt deinen Freund in die Luft!', min: 500, max: 10000, value: 3000, step: 500, unit: ' Kraft' },
                    { id: 'dds2-troll-slowmo', type: 'slider', name: '🐌 Slow-Motion Fluch', description: 'SlowMotion nur auf deinen Freund – er bewegt sich wie in Zeitlupe', min: 0.1, max: 0.9, value: 0.3, step: 0.1, unit: 'x Speed' },
                    { id: 'dds2-troll-steal-boost', type: 'slider', name: '🫳 Klauen leicht gemacht', description: 'StealChanceMultiplier bei Freund auf Max – NPCs klauen seine Drogen!', min: 1, max: 20, value: 10, step: 1, unit: 'x' },
                    { id: 'dds2-troll-police-magnet', type: 'toggle', name: '🚔 Polizei-Magnet', description: 'AlertCircle auf Freund spawnen – Cops rasten auf ihn zu!', enabled: false },
                    { id: 'dds2-troll-cartel-hit', type: 'toggle', name: '💀 Kartell-Attentat', description: 'KillCartelCharacter – aggressiven Kartell-NPC auf Freund hetzen', enabled: false },
                    { id: 'dds2-troll-inventory-drop', type: 'toggle', name: '💨 Inventar-Fumble', description: 'DropItem auf random Items im Inventar deines Freundes – Drogen fallen raus!', enabled: false },
                    { id: 'dds2-troll-freeze', type: 'slider', name: '🧊 Einfrieren', description: 'FreezeMovement – Freund kann sich X Sekunden nicht bewegen', min: 1, max: 15, value: 5, step: 1, unit: ' Sek' },
                    { id: 'dds2-troll-respawn-delay', type: 'slider', name: '⏰ Ewiger Respawn', description: 'GetPlayerRespawnDelay auf Freund erhöhen – ewig warten nach Tod', min: 5, max: 120, value: 30, step: 5, unit: ' Sek' },
                    { id: 'dds2-troll-fear-factor', type: 'slider', name: '😱 Angst-Aura', description: 'WeaponFearFactor + WeaponSusFactor bei Freund – NPCs flippen aus', min: 1, max: 20, value: 10, step: 1, unit: 'x' },
                    { id: 'dds2-troll-movement-swap', type: 'toggle', name: '🔄 Steuerung umkehren', description: 'NetMulticast_MoveForwardBackward invertieren – W geht rückwärts!', enabled: false }
                ]
            }
        ]
    },
    'gladio-and-glory': {
        categories: [
            {
                id: 'gladiator-stats',
                name: '⚔️ Gladiator Stats',
                mods: [
                    { id: 'gg-health-multiplier', type: 'slider', name: 'HP Multiplikator', description: 'Deine maximalen Lebenspunkte erhöhen', min: 1, max: 10, value: 2, step: 0.5, unit: 'x' },
                    { id: 'gg-max-health', type: 'slider', name: 'Max Health setzen', description: 'MaxHealth direkt auf einen Wert setzen', min: 100, max: 10000, value: 500, step: 100, unit: ' HP' },
                    { id: 'gg-damage-multiplier', type: 'slider', name: 'Schadens-Multiplikator', description: 'BaseDamageAmount erhöhen – mehr Schaden pro Treffer', min: 1, max: 10, value: 2, step: 0.5, unit: 'x' },
                    { id: 'gg-base-damage', type: 'slider', name: 'Basis-Schaden setzen', description: 'DamageAmount direkt überschreiben', min: 10, max: 1000, value: 100, step: 10, unit: ' DMG' },
                    { id: 'gg-speed-multiplier', type: 'slider', name: 'Bewegungsgeschwindigkeit', description: 'slopeSpeedMultiplier – schneller laufen', min: 1, max: 5, value: 1.5, step: 0.25, unit: 'x' },
                    { id: 'gg-armor-boost', type: 'slider', name: 'Rüstungs-Boost', description: 'Rüstungswert aus ArmorPoolForPlayer erhöhen', min: 1, max: 5, value: 2, step: 0.5, unit: 'x' }
                ]
            },
            {
                id: 'combat-stamina',
                name: '🏃 Kampf & Ausdauer',
                mods: [
                    { id: 'gg-stamina-regen', type: 'slider', name: 'Ausdauer-Regeneration', description: 'staminaRegen – schneller erholen nach Angriff', min: 1, max: 10, value: 3, step: 0.5, unit: 'x' },
                    { id: 'gg-stamina-cost-reduction', type: 'slider', name: 'Ausdauer-Kosten senken', description: 'grabStaminaCost, runStaminaCost, throwStaminaCost reduzieren', min: 10, max: 100, value: 50, step: 10, unit: '% weniger' },
                    { id: 'gg-max-stamina', type: 'slider', name: 'Max Stamina setzen', description: 'StaminaContainer Limit erhöhen', min: 100, max: 5000, value: 500, step: 100, unit: ' STA' },
                    { id: 'gg-attack-speed', type: 'slider', name: 'Angriffsgeschwindigkeit', description: 'AttackThinkTime reduzieren – schnellere Kombos', min: 1, max: 5, value: 1.5, step: 0.25, unit: 'x' },
                    { id: 'gg-infinite-stamina', type: 'toggle', name: 'Unendliche Ausdauer', description: 'StaminaFillPerc immer auf 100% – AUFFÄLLIG', enabled: false }
                ]
            },
            {
                id: 'arena-glory',
                name: '🏛️ Arena & Glory',
                mods: [
                    { id: 'gg-glory-multiplier', type: 'slider', name: 'Glory Multiplikator', description: 'GloryScore erhöhter Gewinn pro Kampf', min: 1, max: 10, value: 2, step: 1, unit: 'x' },
                    { id: 'gg-kill-score-boost', type: 'slider', name: 'Kill-Score Boost', description: 'killScore pro Kill multiplizieren', min: 1, max: 10, value: 3, step: 1, unit: 'x' },
                    { id: 'gg-kill-boost', type: 'toggle', name: 'Kill Boost aktivieren', description: 'receiveKillBoost permanent aktiv', enabled: false },
                    { id: 'gg-hp-boost-on-kill', type: 'slider', name: 'HP pro Kill', description: 'hpBoost – Lebenspunkte nach jedem Kill regenerieren', min: 5, max: 100, value: 20, step: 5, unit: ' HP' },
                    { id: 'gg-power-boost-on-kill', type: 'slider', name: 'Power pro Kill', description: 'powerBoost – Schadensbonus nach jedem Kill', min: 1, max: 50, value: 5, step: 1, unit: '%' }
                ]
            },
            {
                id: 'weapons',
                name: '🗡️ Waffen',
                mods: [
                    { id: 'gg-weapon-damage-boost', type: 'slider', name: 'Waffen-Schaden', description: 'WeaponDamage Multiplikator für alle Waffen', min: 1, max: 10, value: 2, step: 0.5, unit: 'x' },
                    { id: 'gg-throw-damage', type: 'slider', name: 'Wurf-Schaden', description: 'WeaponThrow Damage erhöhen', min: 1, max: 10, value: 3, step: 0.5, unit: 'x' }
                ]
            },
            {
                id: 'aggressive',
                name: '💀 Aggressive (Auffällig!)',
                mods: [
                    { id: 'gg-god-mode', type: 'toggle', name: 'God Mode', description: 'CurrentHealth wird konstant auf MaxHealth gesetzt – AUFFÄLLIG', enabled: false },
                    { id: 'gg-one-hit-kill', type: 'toggle', name: 'One-Hit Kill', description: 'BaseDamageAmount auf 99999 – AUFFÄLLIG', enabled: false }
                ]
            },
            {
                id: 'system',
                name: '⚙️ System',
                mods: [
                    { id: 'gg-anti-report', type: 'toggle', name: 'Anti-Report Shield', description: 'Modifizierte SyncVars vor Mirror-Server maskieren', enabled: true }
                ]
            }
        ]
    },
    'mall-rivals': {
        categories: [
            {
                id: 'sneaky-economy',
                name: '🥷 Sneaky Wirtschaft',
                mods: [
                    { id: 'income-multiplier', type: 'slider', name: 'Umsatz-Multiplikator', description: 'Jeder Verkauf bringt mehr', min: 1, max: 10, value: 2, step: 0.5, unit: 'x' },
                    { id: 'cost-reduction', type: 'slider', name: 'Kostenreduktion', description: 'Bau- und Einkaufskosten senken', min: 10, max: 100, value: 50, step: 10, unit: '%' },
                    { id: 'rent-reduction', type: 'slider', name: 'Miet-Reduktion', description: 'Laufende Kosten senken', min: 10, max: 100, value: 70, step: 10, unit: '%' },
                    { id: 'xp-boost', type: 'slider', name: 'XP Multiplikator', description: 'Level-Fortschritt beschleunigen', min: 1, max: 10, value: 3, step: 1, unit: 'x' },
                    { id: 'price-markup', type: 'slider', name: 'Preisaufschlag', description: 'Höhere Preise ohne Beschwerden', min: 100, max: 500, value: 150, step: 25, unit: '%' },
                    { id: 'add-money', type: 'slider', name: 'Kapital injizieren', description: 'Sofort Budget hinzufügen', min: 1000, max: 1000000, value: 50000, step: 10000, unit: ' $' },
                    { id: 'infinite-premium', type: 'toggle', name: 'Premium-Währung einfrieren', description: 'Diamanten sinken nie', enabled: false }
                ]
            },
            {
                id: 'shop-management',
                name: '🏗️ Shop Management',
                mods: [
                    { id: 'mr-build-speed', type: 'slider', name: 'Baugeschwindigkeit', description: 'Gebäude schneller fertig', min: 1, max: 10, value: 3, step: 1, unit: 'x' },
                    { id: 'mr-restock-speed', type: 'slider', name: 'Auffüll-Tempo', description: 'Regale schneller auffüllen', min: 1, max: 10, value: 3, step: 1, unit: 'x' },
                    { id: 'staff-efficiency', type: 'slider', name: 'Personal-Effizienz', description: 'Mitarbeiter arbeiten schneller', min: 1, max: 5, value: 2, step: 0.5, unit: 'x' },
                    { id: 'staff-stamina', type: 'slider', name: 'Personal-Ausdauer', description: 'Seltener Pausen nötig', min: 1, max: 5, value: 2, step: 0.5, unit: 'x' },
                    { id: 'expansion-speed', type: 'slider', name: 'Expansions-Tempo', description: 'Erweiterungen schneller', min: 1, max: 5, value: 2, step: 0.5, unit: 'x' },
                    { id: 'unlock-shops', type: 'toggle', name: 'Alle Läden freischalten', description: 'Level-Sperren ignorieren', enabled: false },
                    { id: 'place-anywhere', type: 'toggle', name: 'Freies Platzieren', description: 'Kollision deaktivieren', enabled: false }
                ]
            },
            {
                id: 'customer-control',
                name: '👥 Kunden-Steuerung',
                mods: [
                    { id: 'customer-flow', type: 'slider', name: 'Kundenstrom Boost', description: 'Mehr Kunden in deiner Mall', min: 1, max: 10, value: 2, step: 0.5, unit: 'x' },
                    { id: 'vip-ratio', type: 'slider', name: 'VIP-Anteil', description: 'Mehr zahlungskräftige VIPs', min: 10, max: 100, value: 40, step: 10, unit: '%' },
                    { id: 'spending-boost', type: 'slider', name: 'Kaufbereitschaft', description: 'Kunden kaufen mehr', min: 1, max: 5, value: 2, step: 0.5, unit: 'x' },
                    { id: 'satisfaction-boost', type: 'slider', name: 'Zufriedenheits-Buff', description: 'Zufriedenheit steigt schneller', min: 1, max: 5, value: 2, step: 0.5, unit: 'x' },
                    { id: 'no-complaints', type: 'toggle', name: 'Keine Beschwerden', description: 'Kunden beschweren sich nie', enabled: false }
                ]
            },
            {
                id: 'aggressive',
                name: '💀 Aggressive (Auffällig!)',
                mods: [
                    { id: 'infinite-money', type: 'toggle', name: 'Unendlich Geld', description: 'Kontostand fixieren – AUFFÄLLIG', enabled: false },
                    { id: 'zero-costs', type: 'toggle', name: 'Gratis Bauen', description: 'Alle Kosten $0 – AUFFÄLLIG', enabled: false },
                    { id: 'instant-build', type: 'toggle', name: 'Instant Build', description: 'Sofort fertig – nutze lieber Slider', enabled: false },
                    { id: 'instant-restock', type: 'toggle', name: 'Instant Restock', description: 'Regale sofort voll – nutze lieber Slider', enabled: false }
                ]
            },
            {
                id: 'friend-trolling',
                name: '😈 Freunde Trollen',
                mods: [
                    { id: 'customer-magnet', type: 'toggle', name: 'Kunden-Magnet', description: 'Alle Kunden kommen nur noch zu dir – dein Freund steht alleine da', enabled: false },
                    { id: 'magnet-strength', type: 'slider', name: 'Magnet-Stärke', description: 'Wie viel % der Kunden du abziehst', min: 10, max: 100, value: 30, step: 10, unit: '%' },
                    { id: 'vip-steal', type: 'toggle', name: 'VIP-Diebstahl', description: 'VIP-Kunden werden von deinem Freund zu dir umgeleitet', enabled: false },
                    { id: 'redirect-flow', type: 'slider', name: 'Kundenstrom umleiten', description: 'Reguliere wie viele Kunden dein Freund noch bekommt', min: 0, max: 100, value: 50, step: 10, unit: '%' },
                    { id: 'slow-restock', type: 'toggle', name: 'Gegner-Regale verlangsamen', description: 'Regale deines Freundes füllen sich 5x langsamer', enabled: false },
                    { id: 'tank-prices', type: 'toggle', name: 'Preise drücken', description: 'Senkt die Verkaufspreise im Laden deines Freundes', enabled: false },
                    { id: 'steal-inventory', type: 'toggle', name: 'Waren klauen', description: 'Seltene Items aus seinem Lager in deins teleportieren', enabled: false },
                    { id: 'spawn-trash', type: 'toggle', name: 'Müll spawnen', description: 'Spawnt Müll im Kaufhaus deines Freundes – Rating sinkt', enabled: false },
                    { id: 'fake-health-inspector', type: 'toggle', name: 'Gesundheitsamt schicken', description: 'Ein Laden deines Freundes wird kurz geschlossen', enabled: false },
                    { id: 'freeze-opponent-staff', type: 'toggle', name: 'Personal einfrieren', description: 'Mitarbeiter deines Freundes machen spontan Pause', enabled: false },
                    { id: 'destroy-ratings', type: 'toggle', name: '1-Stern Bewertung', description: 'Spawnt schlechte Reviews bei deinem Freund', enabled: false },
                    { id: 'bankrupt-opponents', type: 'toggle', name: 'Budget auf $0 setzen', description: 'Sein Konto leeren – der Klassiker', enabled: false }
                ]
            },
            {
                id: 'system',
                name: '⚙️ Engine & System',
                mods: [
                    { id: 'freeze-time', type: 'toggle', name: 'Uhrzeit einfrieren', description: 'Tageszyklus stoppen', enabled: false },
                    { id: 'univ-speedhack', type: 'slider', name: 'Globaler Speedhack', description: 'Simulation beschleunigen', min: 1, max: 10, value: 2, step: 0.5, unit: 'x' },
                    { id: 'anti-report', type: 'toggle', name: 'Anti-Report Shield', description: 'Stats vor Server verstecken', enabled: true },
                    { id: 'packet-manipulation', type: 'toggle', name: 'Paket-Manipulation', description: 'Server Integrity umgehen', enabled: false }
                ]
            }
        ]
    },
    'war-selection': {
        categories: [
            {
                id: 'sneaky-resources',
                name: '🥷 Sneaky Mode – Ressourcen',
                mods: [
                    { id: 'food-multiplier', type: 'slider', name: 'Nahrung Multiplikator', description: 'Erhöht jede Nahrungseinnahme – wirkt natürlich', min: 1, max: 10, value: 2, unit: 'x' },
                    { id: 'wood-multiplier', type: 'slider', name: 'Holz Multiplikator', description: 'Holzfäller bringen mehr pro Trip', min: 1, max: 10, value: 2, unit: 'x' },
                    { id: 'stone-multiplier', type: 'slider', name: 'Stein Multiplikator', description: 'Steinbruch-Ertrag multiplizieren', min: 1, max: 10, value: 2, unit: 'x' },
                    { id: 'iron-multiplier', type: 'slider', name: 'Eisen Multiplikator', description: 'Eisen-Ertrag pro Worker multiplizieren', min: 1, max: 10, value: 2, unit: 'x' },
                    { id: 'global-income-boost', type: 'slider', name: 'Globaler Einkommens-Boost', description: 'Alle Einnahmen pauschal multiplizieren', min: 1, max: 5, value: 2, step: 0.5, unit: 'x' },
                    { id: 'reduced-costs', type: 'slider', name: 'Reduzierte Baukosten', description: 'Alle Kosten prozentual senken', min: 10, max: 100, value: 50, step: 10, unit: '%' },
                    { id: 'pop-cap-boost', type: 'slider', name: 'Bevölkerungs-Limit +', description: 'Max-Limit erhöhen (nicht unendlich)', min: 50, max: 500, value: 100, step: 50, unit: '' },
                    { id: 'zero-pop-cost', type: 'toggle', name: 'Keine Bevölkerungskosten', description: 'Einheiten verbrauchen keinen Wohnraum', enabled: false }
                ]
            },
            {
                id: 'unit-buffs',
                name: '⚔️ Unit Buffs – Truppen stärken',
                mods: [
                    { id: 'unit-hp-buff', type: 'slider', name: 'Einheiten HP Buff', description: 'Mehr Lebenspunkte – wie ein verstecktes Upgrade', min: 1, max: 5, value: 1.5, step: 0.5, unit: 'x' },
                    { id: 'unit-damage-buff', type: 'slider', name: 'Schadens-Buff', description: 'Truppen teilen mehr Schaden aus', min: 1, max: 5, value: 1.5, step: 0.5, unit: 'x' },
                    { id: 'unit-speed-buff', type: 'slider', name: 'Bewegungs-Tempo', description: 'Truppen bewegen sich schneller – perfekt für Rushes', min: 1, max: 3, value: 1.3, step: 0.1, unit: 'x' },
                    { id: 'unit-armor-buff', type: 'slider', name: 'Rüstungs-Buff', description: 'Erhöht die Rüstungswerte aller Einheiten', min: 1, max: 5, value: 2, step: 0.5, unit: 'x' },
                    { id: 'unit-range-buff', type: 'slider', name: 'Angriffsreichweite +', description: 'Fernkämpfer schießen weiter', min: 1, max: 3, value: 1.5, step: 0.25, unit: 'x' },
                    { id: 'unit-heal-regen', type: 'slider', name: 'Passive Regeneration', description: 'Einheiten regenerieren langsam HP', min: 1, max: 10, value: 3, step: 1, unit: ' HP/s' },
                    { id: 'train-speed', type: 'slider', name: 'Rekrutierungs-Tempo', description: 'Einheiten schneller ausbilden (nicht instant)', min: 1, max: 10, value: 3, step: 1, unit: 'x' },
                    { id: 'build-speed', type: 'slider', name: 'Baugeschwindigkeit', description: 'Gebäude schneller fertig', min: 1, max: 10, value: 3, step: 1, unit: 'x' },
                    { id: 'research-speed', type: 'slider', name: 'Forschungs-Tempo', description: 'Upgrades schneller erforschen', min: 1, max: 10, value: 3, step: 1, unit: 'x' },
                    { id: 'age-up-speed', type: 'slider', name: 'Epochen-Aufstieg Tempo', description: 'Zeitalter-Wechsel beschleunigen', min: 1, max: 10, value: 5, step: 1, unit: 'x' }
                ]
            },
            {
                id: 'aggressive',
                name: '💀 Aggressive Mode (Auffällig!)',
                mods: [
                    { id: 'god-mode-units', type: 'toggle', name: 'God Mode (Armee)', description: 'Eigene Einheiten nehmen 0 Schaden – AUFFÄLLIG', enabled: false },
                    { id: 'one-hit-kill', type: 'toggle', name: 'One-Hit Kill', description: 'Feinde sterben sofort – EXTREM AUFFÄLLIG', enabled: false },
                    { id: 'instant-train', type: 'toggle', name: 'Instant Rekrutierung', description: '0-Sekunden Spawn – nutze lieber den Tempo-Slider', enabled: false },
                    { id: 'instant-build', type: 'toggle', name: 'Instant Bauen', description: 'Gebäude sofort fertig – nutze lieber den Tempo-Slider', enabled: false }
                ]
            },
            {
                id: 'visual-engine',
                name: '👁️ Sichtbarkeit & ESP',
                mods: [
                    { id: 'maphack', type: 'toggle', name: 'Globaler Maphack', description: 'Fog of War komplett entfernen', enabled: false },
                    { id: 'partial-fog', type: 'slider', name: 'Fog Reduction', description: 'Fog reduzieren statt entfernen – subtiler', min: 0, max: 100, value: 50, step: 10, unit: '%' },
                    { id: 'esp-units', type: 'toggle', name: 'Einheiten ESP', description: 'Feindliche Einheiten durch Fog sehen', enabled: false },
                    { id: 'zoom-hack', type: 'slider', name: 'Kamera Zoom-Limit', description: 'Mehr Übersicht durch erhöhtes Zoom', min: 1, max: 5, value: 2, step: 0.5, unit: 'x' },
                    { id: 'screenshot-cleaner', type: 'toggle', name: 'Screenshot Cleaner', description: 'Visuals in Anti-Cheat Screenshots verbergen', enabled: true }
                ]
            },
            {
                id: 'multiplayer-troll',
                name: '🎯 Lobby Control (Multiplayer)',
                mods: [
                    { id: 'report-blocker', type: 'toggle', name: 'Report Blocker', description: 'Blockiert ausgehende Reports', enabled: false },
                    { id: 'drain-enemy-banks', type: 'toggle', name: 'Ressourcen stehlen', description: 'Gegner-Ressourcen kontinuierlich abziehen', enabled: false },
                    { id: 'drain-speed', type: 'slider', name: 'Drain-Geschwindigkeit', description: 'Wie schnell Ressourcen abgezogen werden', min: 1, max: 50, value: 5, step: 1, unit: '/s' },
                    { id: 'nuke-economy', type: 'toggle', name: 'Wirtschafts-Crash', description: 'Einkommen aller Gegner auf 0', enabled: false },
                    { id: 'mind-control', type: 'toggle', name: 'Einheiten kontrollieren', description: 'Feindliche Einheiten übernehmen', enabled: false },
                    { id: 'force-lag-spike', type: 'toggle', name: 'Lobby Lag-Spike', description: 'Gezielte Lags bei Gegnern', enabled: false },
                    { id: 'crash-lobby', type: 'toggle', name: 'Lobby Crasher', description: 'Gameserver überlasten (Vorsicht!)', enabled: false }
                ]
            }
        ]
    },
    'upload-labs': {
        categories: [
            {
                id: 'resources',
                name: '💰 Ressourcen & Einkommen',
                mods: [
                    { id: 'ul-money-multiplier', type: 'slider', name: 'Einkommens-Multiplikator', description: 'Multipliziere dein Geld-Einkommen pro Sekunde', min: 1, max: 100, value: 10, step: 1, unit: 'x' },
                    { id: 'ul-set-money', type: 'slider', name: 'Bargeld setzen', description: 'Setze deinen Kontostand direkt auf einen Wert', min: 1000, max: 1000000000, value: 1000000, step: 10000, unit: ' $' },
                    { id: 'ul-research-multiplier', type: 'slider', name: 'Forschungs-Punkte', description: 'Erhalte drastisch mehr Research Points', min: 1, max: 100, value: 5, step: 1, unit: 'x' },
                    { id: 'ul-tokens-multiplier', type: 'slider', name: 'Token-Multiplikator', description: 'Multipliziere Daily Tokens (Premium-Währung)', min: 1, max: 100, value: 10, step: 1, unit: 'x' },
                    { id: 'ul-set-tokens', type: 'slider', name: 'Tokens setzen', description: 'Setze deine Daily Tokens auf einen festen Wert', min: 100, max: 9999999, value: 100000, step: 1000, unit: ' T' },
                    { id: 'ul-file-value-multiplier', type: 'slider', name: 'Datei-Wert Multiplikator', description: 'Jede hochgeladene Datei bringt X-fache Credits', min: 1, max: 1000, value: 25, step: 1, unit: 'x' },
                    { id: 'ul-offline-earnings-mult', type: 'slider', name: 'Offline-Verdienste', description: 'Verdiene ein Vielfaches im Hintergrund', min: 1, max: 100, value: 10, step: 1, unit: 'x' },
                    { id: 'ul-node-cost-reduction', type: 'slider', name: 'Node-Kosten reduzieren', description: 'Reduziere die Kaufkosten jedes Nodes', min: 0, max: 100, value: 90, step: 5, unit: '%' }
                ]
            },
            {
                id: 'automation',
                name: '⚡ Speed & Automation',
                mods: [
                    { id: 'ul-global-speedhack', type: 'slider', name: 'Globaler Speedhack', description: 'Gesamte Simulation massiv beschleunigen', min: 1, max: 50, value: 5, step: 1, unit: 'x' },
                    { id: 'ul-instant-download', type: 'toggle', name: 'Instant Downloads', description: 'Download-Nodes schließen sofort ab', enabled: true },
                    { id: 'ul-instant-upload', type: 'toggle', name: 'Instant Uploads', description: 'Upload-Nodes verschicken Dateien ohne Verzögerung', enabled: true },
                    { id: 'ul-instant-process', type: 'toggle', name: 'Instant Processing', description: 'Processing-/Thread-Nodes erledigen Aufgaben in 0s', enabled: true },
                    { id: 'ul-instant-research', type: 'toggle', name: 'Instant Research', description: 'Forschung ist in 0 Sekunden abgeschlossen', enabled: true },
                    { id: 'ul-instant-hack', type: 'toggle', name: 'Instant Hacking', description: 'Hacking-Timer sofort beenden', enabled: true },
                    { id: 'ul-instant-commit', type: 'toggle', name: 'Instant Code Commit', description: 'Code Commits sofort fertigstellen', enabled: true },
                    { id: 'ul-no-cooldowns', type: 'toggle', name: 'Keine Cooldowns', description: 'Alle Cooldowns entfernen', enabled: true },
                    { id: 'ul-auto-upgrade', type: 'toggle', name: 'Auto-Upgrade', description: 'Upgradet jeden Node automatisch, sobald möglich', enabled: true },
                    { id: 'ul-auto-collect', type: 'toggle', name: 'Auto-Collect', description: 'Sammelt fertige Dateien & Ressourcen automatisch ein', enabled: true }
                ]
            },
            {
                id: 'system',
                name: '🧩 Nodes & System',
                mods: [
                    { id: 'ul-infinite-portals', type: 'toggle', name: 'Unbegrenzte Portale', description: 'Portal-Limit entfernt', enabled: true },
                    { id: 'ul-infinite-threads', type: 'toggle', name: 'Unbegrenzte Threads', description: 'Thread-Limit am CPU/GPU entfernt', enabled: true },
                    { id: 'ul-unlock-all-nodes', type: 'toggle', name: 'Alle Node-Typen freischalten', description: 'Jeder Node-Typ sofort verfügbar', enabled: true },
                    { id: 'ul-no-bottlenecks', type: 'toggle', name: 'Engpässe ignorieren', description: 'Bottleneck-Drosselung entfernt', enabled: true },
                    { id: 'ul-virus-immunity', type: 'toggle', name: 'Viren-Immunität', description: 'Immun gegen Viren & Firewalls', enabled: true }
                ]
            },
            {
                id: 'aggressive',
                name: '💀 Aggressive (Auffällig!)',
                mods: [
                    { id: 'ul-zero-cost', type: 'toggle', name: 'Alle Upgrades $0', description: 'Jedes Upgrade und Node ist komplett kostenlos', enabled: false },
                    { id: 'ul-creative-mode', type: 'toggle', name: 'Kreativ-Modus', description: 'Alles frei, alles kostenlos, keine Limits', enabled: false },
                    { id: 'ul-achievement-unlock', type: 'toggle', name: 'Alle Achievements', description: 'Schaltet sämtliche Steam-Achievements frei', enabled: false }
                ]
            }
        ]
    }
}

export { games, modData }
